import { NavLink, NavLinkProps } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Colors, helperLinkReset, helperListItemHover, media } from '@utex/ui-kit';

export const Container = styled('div')`
  & + & {
    border-top: 1px solid ${Colors.ut.border10};
  }
`;

export interface ItemProps extends NavLinkProps {
  disabled?: boolean;
}

export const Item = styled(NavLink)<ItemProps>`
  ${helperLinkReset};
  ${({ disabled }) => !disabled && helperListItemHover()};
  display: block;
  width: 100%;
  padding: 1.5rem var(--gap);
  text-align: left;
  ${({ disabled }) => css`
    opacity: ${disabled ? 0.5 : 1};
    cursor: ${disabled && 'text'};
  `}

  &.active {
    background-color: ${Colors.ut.primaryDim};
  }

  @media ${media.phonablet} {
    padding: 1rem var(--gap);
  }
`;

export const Icon = styled('img')`
  flex-shrink: 0;
  width: 5rem;
  height: 5rem;
  margin-right: 2rem;

  @media ${media.mobile} {
    width: 3.6rem;
    height: 3.6rem;
    margin-right: 1.6rem;
  }
`;
